import React from "react";
import {
    TableRow,
    TableCell,
    Checkbox,
    Chip,
    IconButton,
    Tooltip,
    Box,
} from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useLanguage } from '../../../../context/LanguageContext';
import { ImportedList } from '../types';

interface ListTableRowProps {
    list: ImportedList;
    isSelected: boolean;
    typeColor: "primary" | "info" | "success" | "warning" | "secondary";
    typeTranslationKey: string;
    onSelect: (id: string | number) => void;
    onVisualise: (list: ImportedList) => void;
    onDelete: (list: ImportedList) => void;
}

const ListTableRow = ({
    list,
    isSelected,
    typeColor,
    typeTranslationKey,
    onSelect,
    onVisualise,
    onDelete,
}: ListTableRowProps) => {
    const { t } = useLanguage();

    return (
        <TableRow hover>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onChange={() => onSelect(list.LIST_ID)}
                />
            </TableCell>
            <TableCell>
                <Tooltip title={list.LABEL} arrow>
                    <span
                        style={{
                            maxWidth: 800,
                            display: "inline-block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            verticalAlign: "bottom"
                        }}
                    >
                        {list.LABEL}
                    </span>
                </Tooltip>
            </TableCell>
            <TableCell>
                {list.IMPORT_DATE ? new Date(list.IMPORT_DATE).toLocaleString() : "-"}
            </TableCell>
            <TableCell align="center">{list.TOTAL_ACCOUNTS || 0}</TableCell>
            <TableCell align="center">
                <Chip
                    variant="outlined"
                    color={typeColor}
                    size="small"
                    sx={{ pointerEvents: "none" }}
                    label={t(`pages.clients.importList.${typeTranslationKey}`)}
                />
            </TableCell>
            <TableCell align="center">
                <Box display="flex" gap={1} justifyContent="center">
                    <Tooltip title={t("common.details")}>
                        <IconButton
                            size="small"
                            color="primary"
                            onClick={(e) => {
                                e.preventDefault();
                                onVisualise(list);
                            }}
                            type="button"
                        >
                            <VisibilityIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={t("common.delete")}>
                        <IconButton
                            size="small"
                            color="error"
                            onClick={(e) => {
                                e.preventDefault();
                                onDelete(list);
                            }}
                            type="button"
                        >
                            <DeleteOutlineIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
            </TableCell>

        </TableRow>
    );
};

export default ListTableRow;
